import { isBrowser } from '~/shared/utils/platform';
import { lgMinWidth } from '~/theme/lib/breakpoints';

export const getIsMobile = () => isBrowser && window.innerWidth <= lgMinWidth;
